module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "view",
    on: {
      "mouseover": _vm.displayState,
      "mouseout": _vm.hideState
    }
  }, [_c('div', {
    staticClass: "window"
  }, [_c('div', {
    staticClass: "window-header"
  }, [_c('div', {
    staticClass: "action-buttons"
  }), _vm._v(" "), _c('select', {
    staticClass: "language"
  }, [_c('option', {
    attrs: {
      "value": "JavaScript",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.data.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "window-body"
  }, [_c('textarea', {
    staticClass: "code-input",
    domProps: {
      "value": _vm.initCode()
    },
    on: {
      "input": function($event) {
        _vm.updataCode($event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "credits"
  }, [_vm._v("\n            Enjoy yourself!\n        ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "code-output"
  }, [_vm._v("\n                    "), _c('code', {
    staticClass: "language-javascript"
  }), _vm._v("\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-609582cf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CodeEditor.vue
// module id = 85
// module chunks = 0